import { render, staticRenderFns } from "./EndorsementChart.vue?vue&type=template&id=13738c2d&scoped=true&"
import script from "./EndorsementChart.vue?vue&type=script&lang=js&"
export * from "./EndorsementChart.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementChart.vue?vue&type=style&index=0&id=13738c2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13738c2d",
  null
  
)

export default component.exports